/**
 * Opções de status usadas no filtro (modal) e na tabela.
 * O valor vazio ("") representa "todos".
 */
export const STATUS_OPTIONS = [
    { value: "pendente", label: "Pendente" },
    { value: "ok", label: "Conciliado" },
    { value: "incorreto", label: "Conciliado (valor errado)" },
    { value: "sem_valor", label: "Sem nenhum valor" },
];

export const STATUS_LABELS = STATUS_OPTIONS.reduce((acc, opt) => {
    acc[opt.value] = opt.label;
    return acc;
}, {});

function getConciliacaoStatus(row) {
    const conciliacao = row?.conciliacao;
    if (!conciliacao || !conciliacao.conciliado) return "pendente";

    const valorConciliado = Number(conciliacao.valor_conciliado);
    const saldoAtual = Number(row?.saldo);
    if (Number.isNaN(valorConciliado) || Number.isNaN(saldoAtual)) return "pendente";

    const toCents = (value) => Math.round(value * 100);
    return toCents(valorConciliado) === toCents(saldoAtual) ? "ok" : "incorreto";
}

function isContaZerada(row) {
    const valores = [
        row?.debito,
        row?.credito,
        row?.movimento_mes,
        row?.saldo,
        row?.saldo_anterior,
    ];
    return valores.every((valor) => Math.round(Number(valor) * 100) === 0);
}

/**
 * Status de uma linha (ordem de prioridade):
 * - "ok":        conciliada e o valor bate com o saldo atual
 * - "incorreto": conciliada, mas o valor difere do saldo atual
 * - "sem_valor": não conciliada e sem nenhum valor (tudo zerado)
 * - "pendente":  não conciliada, mas com algum valor
 */
export function getContaStatus(row) {
    const conciliacao = getConciliacaoStatus(row);
    if (conciliacao === "ok" || conciliacao === "incorreto") return conciliacao;
    if (isContaZerada(row)) return "sem_valor";
    return "pendente";
}
